import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type SubjectMemberPayload = {
	readonly user: { readonly id: number };
	readonly access: LabeledValuePayload;
};

export type SubjectMembersFetchedPayload = {
	subjectId: number;
	members: SubjectMemberPayload[];
};

export type SubjectMembersFetchedAction = {
	type: 'SUBJECT_MEMBERS_FETCHED';
	payload: SubjectMembersFetchedPayload;
	typeKey: string;
};

export default (
	subjectId: number,
	members: SubjectMemberPayload[],
	typeKey: string,
): SubjectMembersFetchedAction => ({
	type: 'SUBJECT_MEMBERS_FETCHED',
	payload: { subjectId, members },
	typeKey,
});
